import { merge } from 'lodash';
import defaultConfig from './default';
import envDev from './env/development';
import envProd from './env/production';

let env: any;

if (import.meta.env.DEV) {
  env = envDev;
} else {
  env = envProd;

  // Support both VITE_API_URL (full URL or relative path) and VITE_HOST (hostname only)
  const apiUrl = import.meta.env.VITE_API_URL;
  const host = import.meta.env.VITE_HOST;

  if (apiUrl) {
    if (apiUrl.match(/^https?:\/\//)) {
      // Full URL (e.g., http://46.224.191.239:3000/api/v1)
      // Extract the base hostname and construct URLs
      const baseMatch = apiUrl.match(/^(https?:\/\/[^/]+)/);
      const baseUrl = baseMatch ? baseMatch[1] : '';
      env.apiBaseUrl = `${baseUrl}/api/v1`;
      env.apiBaseUrlV2 = `${baseUrl}/api/v1`;
      env.dashboardUrl = `${baseUrl}/dashboard`;
    } else {
      // Relative path (e.g., /api/v1) - use as-is for unified API access
      env.apiBaseUrl = apiUrl;
      env.apiBaseUrlV2 = apiUrl; // Both V1 and V2 now use the same /api/v1 prefix
      // Absolut machen: dashboardUrl geht als success/cancel/return-URL an Stripe, und die API
      // verlangt eine vollständige URL (relativ → VALIDATION_ERROR beim Kundenportal).
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      env.dashboardUrl = origin + apiUrl.replace(/\/api\/v\d+$/, '') + '/dashboard';
    }
  } else if (host) {
    // Legacy VITE_HOST support (hostname only, assumes https)
    const protocol = host.includes('localhost') ? 'http' : 'https';
    env.apiBaseUrl = `${protocol}://${host}/api/v1`;
    env.apiBaseUrlV2 = `${protocol}://${host}/api/v1`;
    env.dashboardUrl = `${protocol}://${host}/dashboard`;
  }
}

// Merge the default config with the environment specific config
// Environment config attributes will overwrite the default, when present in both
const mergedConfig = merge(defaultConfig, env);
export default mergedConfig;
